import styled from 'styled-components';
import { units } from '@m/alchemy-theme';

export const StyledPublishBlockedDialog = styled.div`
  font-family: "Nunito", -apple-system, system-ui, BlinkMacSystemFont, Roboto, Segoe UI, Oxygen Sans, Ubuntu, Helvetica Nue, sans-serif;
  font-size: ${units(1.75)};
  line-height: ${units(2.5)};

  p {
    margin-bottom: ${units(2)};
  }

  ul {
    margin-top: ${units(0.5)};
    margin-bottom: ${units(2)};
  }

  li {
    margin-bottom: ${units(0.5)};
  }

  strong,
  b {
    font-weight: bold;
  }

  .instruction {
    margin-top: ${units(2)};
  }
`;
